import { CrownSimpleIcon } from '@/shared';

export function NotFoundSubscriptions() {
	return (
		<div className="relative flex flex-col items-center gap-6 rounded-xl border border-[#FFFFFF08] bg-[#F5F8FF] p-6 md:flex-row md:pr-20 lg:p-8 lg:pr-20">
			<div className="rounded-lg bg-white bg-gradient-to-t from-[#0149FF14] to-[#0149FF14] p-6">
				<CrownSimpleIcon className="size-12" />
			</div>
			<div className="flex-1 space-y-1">
				<div className="text-red">Нет активной подписки</div>
			</div>
		</div>
	);
}
